import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";

const Data = [
  {
    id: 1,
    name: "Franchise Store Mapped",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png",
    backgroundColor: "#1F78D9",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/Franchise-Store-Mapped-List",
  },
  {
    id: 2,
    name: "Franchise's Rate",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/franchises-rate-list",
  },
  {
    id: 3,
    name: "Franchise's User",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#ab3c3cff",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/franchise-user-mapped-list",
  },

  {
    id: 4,
    name: "Franchise Store",
    icon: "images/increase.png",
    backgroundColor: "#AD39BF",
    tintColor: null,
    navigation: "/franchise-store-list",
  },

  // {
  //   id: 4,
  //   name: "Franchise Store Order Revenue",
  //   icon: "images/increase.png",
  //   backgroundColor: "#AD39BF",
  //   tintColor: null,
  //   navigation: "/franchise-store-order-revenue",
  // },

  // {
  //   id: 5,
  //   name: "Franchise Store Service Wise Revenue",
  //   icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
  //   backgroundColor: "#1F78D9",
  //   tintColor: null,
  //   navigation: "/franchise-store-service-wise-revenue",
  // },
];

const FranchiseConfigList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { franchiseItem } = location.state || {}; // Fallback to prevent undefined errors

  const [modalMenuVisible, setModalMenuVisible] = useState(false);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  const brandOfferModal = brandProfileData.brandOffModel;
  const enabledPaymentGateway = brandProfileData.enabledPaymentGateway;

  const filteredData = Data.filter(item =>  brandOfferModal || item.id !== 6).filter((item) => enabledPaymentGateway || item.id !== 8)

  const renderCardItem = () => {
    return filteredData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      return (
        <div
          onClick={() =>
            navigate(item.navigation, {
              state: {
                item: franchiseItem,
              },
            })
          }
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };
 
 

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Franchise-List")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise Configuration
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-3">
        {filteredData?.length ? (
          renderCardItem()
        ) : (
          <p>No card data available.</p>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              // width: 100,
              // height: 50,
              alignSelf: "center",
            }}
          />
        </div>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default FranchiseConfigList;
